import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { CheckCircle2 } from "lucide-react";

export default function SuccessPage() {
  return (
    <div className="bg-grain min-h-screen" data-testid="success-page">
      <Header />
      <main className="py-24">
        <div className="max-w-2xl mx-auto px-5 sm:px-8 text-center relative">
          <div className="corner-bracket tl" />
          <div className="corner-bracket tr" />
          <div className="corner-bracket bl" />
          <div className="corner-bracket br" />
          <div className="py-12">
            <div className="mx-auto w-16 h-16 rounded-full bg-[#3B9EFF]/15 border border-[#3B9EFF]/50 flex items-center justify-center text-[#3B9EFF]">
              <CheckCircle2 size={32} />
            </div>
            <h1 className="mt-6 font-display font-black text-white text-5xl tracking-tighter">
              We've got it. <span className="text-[#3B9EFF]">Now we build.</span>
            </h1>
            <p className="mt-5 text-[#A0AABF] text-lg">
              Your brief is in. Our team is already on it. Expect your content within{" "}
              <span className="text-white font-semibold">72–96 hours</span> (depending on project size) via Google Drive link.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <Link to="/" className="btn-secondary" data-testid="success-home-btn">Back to home</Link>
              <Link to="/offer/monthly-175" className="btn-primary" data-testid="success-upsell-btn">
                Go Monthly →
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
